/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {FlexLayoutModule} from "@angular/flex-layout";

import {MatFormFieldModule} from "@angular/material/form-field";
import {MatTreeModule} from "@angular/material/tree";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatTableModule} from "@angular/material/table";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatCardModule} from "@angular/material/card";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSelectModule} from "@angular/material/select";
import {MatRippleModule} from "@angular/material/core";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatDialogModule} from "@angular/material/dialog";

import {UpdateListComponent} from "./update-dialog/update-dialog.component";
import {ListComponent} from "./list.component";
import {AigPipeModule} from "../../base/pipes/aig-pipe.module";
import {BasePipeModule} from "../../../platform/base/pipes/base-pipe.module";

@NgModule({
	declarations: [
		ListComponent,
		UpdateListComponent,
	],
	imports: [
		CommonModule,
		DragDropModule,
		FormsModule,
		ReactiveFormsModule,

		FlexLayoutModule,

		MatListModule,
		MatTreeModule,
		MatFormFieldModule,
		MatCardModule,
		MatIconModule,
		MatButtonModule,
		MatCheckboxModule,
		MatInputModule,
		MatRadioModule,
		MatDatepickerModule,
		MatTableModule,
		MatSelectModule,
		MatRippleModule,
		MatTooltipModule,
		MatSlideToggleModule,
		MatDialogModule,

		BasePipeModule,
		AigPipeModule
	],
	exports: [
		ListComponent,
	],
	bootstrap: [
		UpdateListComponent,
	],
})

export class ListModule {
}
